import react, { useState, useEffect } from "react";
import ProductList from "../components/admin-panel/ProductList/ProductList";
import { useParams } from "react-router-dom";
import sendRequest from "hooks/useAxios";
import Pagination from "rc-pagination";
import "../assets/index.less";
import Loader from "utils/Loader";
import { RiListSettingsLine } from "react-icons/ri";
import Title from "common/Title";
import { Helmet } from "react-helmet";
export default function AdminProduct({ logo }) {
  const [productList, setProductList] = useState([]);
  // let bId = useParams();
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function loadPage() {
      await sendRequest("get_main_products").then(({ data }) => {
        setProductList(data.products);
        setLoading(false);
      });
      console.log("product list is :", productList);
    }
    loadPage();
  }, [update]);
  const [currentPage, setCurrentPage] = useState(1);
  // const sliceArray = array => {
  //   return array.slice((currentPage - 1) * 6, (currentPage - 1) * 6 + 6);
  // };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`لیست محصولات`} </title>
        {/* <link rel="shortcut icon" href={`${logo}`} /> */}
      </Helmet>
      {loading && <Loader></Loader>}
      <Title
        color="rgb(244 124 96)"
        title="لیست محصولات"
        icon={RiListSettingsLine}
      />
      <ProductList data={productList} update={update} setUpdate={setUpdate} />
      {/* <div>
        <Pagination
          className="text-center my-2"
          total={ProductList.length}
          pageSize={6}
          current={currentPage}
          // onChange={page => {
          //   setCurrentPage(page);
          // }}
        />
      </div> */}
    </div>
  );
}
